// extracted by mini-css-extract-plugin
export var content = "PostContent-module--content--5e6bc";
export var image = "PostContent-module--image--c4b25";